import { TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedStaffNoteDeletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface StaffNoteDeletedEventProps {
  event: DiscriminatedStaffNoteDeletedEvent;
}

export const StaffNoteDeletedEvent: React.FC<StaffNoteDeletedEventProps> = ({
  event,
}) => {
  const { staff_note } = event.payload;
  const user = getUserFromEvent(event);

  const entityName = staff_note?.content
    ? `${staff_note.content.substring(0, 50)}...`
    : 'Note';

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
          <TrashIcon className="h-4 w-4 text-red-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>{entityName}</ActivityTitle>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Note Deleted"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
